// extracted by mini-css-extract-plugin
export default {"Flash":"InvalidCitationWarning-module__Flash--k8ISS"};